import type { DocumentFields, Field } from "./state"

export const isActiveColumn = (
  column: string | undefined,
  fields: DocumentFields,
) =>
  column && Object.values(fields).some((field: Field) => field.value === column)
